const CENTS_MULTIPLIER = 100;

// https://medium.com/javascript-in-plain-english/why-0-1-0-2-0-3-in-javascript-d7e218224a72
export default function convertToCents(amount: string): number {
  return Number((Number(amount) * CENTS_MULTIPLIER).toFixed());
}
